/**
 * API响应处理工具
 * 职责: 统一处理Django REST Framework的分页响应格式
 * 限制: <50行
 */

/**
 * 从DRF分页响应中提取数据数组
 * 
 * DRF分页格式: {count, next, previous, results: [...]}
 * 非分页格式: [...] (直接数组)
 * 
 * @param responseData - API响应的data字段
 * @returns 数据数组
 */
export function extractResultsFromResponse<T>(responseData: any): T[] {
  // 处理分页响应格式: {count, next, previous, results: [...]}
  if (responseData && typeof responseData === 'object' && 'results' in responseData) {
    const results = responseData.results;
    return Array.isArray(results) ? results : [];
  }
  
  // 如果直接返回数组
  if (Array.isArray(responseData)) {
    return responseData;
  }
  
  // 如果返回的是空对象或其他格式，返回空数组并警告
  if (responseData && typeof responseData === 'object') {
    console.warn('API返回了意外的数据格式（不是数组也不是分页格式）:', responseData);
  }
  
  return [];
}

